module.exports = __webpack_public_path__ + "img/logo.eef23225.svg";